import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { Toaster } from '../ui/sonner';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}
